<template>
  <div class="footer">
    <div>
      <ul class="contact">
        <li>Contact</li>
        <li>TEL: 07-1234567</li>
        <li>MAIL: gowhere@gmail.com</li>
        <li>Time: 12:00 - 22:00</li>
      </ul>
      <div>
        <h5>©Copright 2019 TSAI-HUNG LI</h5>
        <p>僅個人作品練習，無任何商業用途</p>
      </div>
      <ul class="follow">
        <li>Follow Go! Where?</li>
        <li><i class="fab fa-instagram"></i><a href="#">Instagram</a></li>
        <li><i class="fab fa-line"></i><a href="#">Line</a></li>
        <li><i class="fab fa-facebook-f"></i><a href="#">Facebook</a></li>
        <li><i class="fab fa-twitter"></i><a href="#">Twitter</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'foot',
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
@import '../assets/sass/foot.scss';
</style>
